// Module Import
//---------------------------------
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import TypographyAtom from '../../atoms/typography/typography'
import { brandIvory, brandOrange } from '../../../assets/consts/color'

// Component Import
//---------------------------------

// Styled Component Declarations
//---------------------------------
const SectionHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 100%;
  gap: 16px;
  margin-bottom: 40px;
  position: relative;

  h3 {
    margin: 0;
  }

  &:before {
    background-color: ${brandOrange};
    content: '';
    width: 4px;
    flex-shrink: 0;
  }

  &:not(&:has(h4)):after {
    background-color: ${brandIvory};
    content: '';
    flex: auto;
  }

  h3,
  h2 {
    margin-top: 0;
    &.large {
      font-size: 24px;
      font-weight: 500;
      @media only screen and (min-width: 48em) {
        font-size: 28px;
      }
      @media only screen and (min-width: 64em) {
        font-size: 39px;
      }
    }
  }

  h4.large {
    &.large {
      font-size: 18px;
      font-weight: 500;
      @media only screen and (min-width: 48em) {
        font-size: 22px;
      }
      @media only screen and (min-width: 64em) {
        font-size: 28px;
      }
    }
  }

  &.margin-none {
    margin-bottom: 0;
  }

  &.thin {
    h3 {
      font-weight: 500;
    }
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
`

// Component Export
//---------------------------------
export default function SectionHeader({
  titleTag,
  subtitleTag,
  headerCopy,
  subTitle,
  large,
  marginNone,
  thin,
  className = null,
}) {
  return (
    <SectionHeaderWrapper
      className={`${className || ''} ${marginNone ? 'margin-none' : ''} ${thin ? 'thin' : ''}`}
    >
      <Content>
        <TypographyAtom
          className={large ? 'large' : ''}
          as={titleTag || 'h2'}
          type="H2"
          copy={headerCopy}
          weight="Light"
        />
        {subTitle &&
          (subTitle.raw ? (
            <TypographyAtom type="BlockText" copyBlock={subTitle} weight="BlockText" />
          ) : (
            <TypographyAtom
              as={subtitleTag || 'h3'}
              className={large ? 'large' : ''}
              type="H3"
              copy={subTitle}
              weight="Thin"
            />
          ))}
      </Content>
    </SectionHeaderWrapper>
  )
}

SectionHeader.propTypes = {
  headerCopy: PropTypes.string.isRequired,
  className: PropTypes.string,
}
